var _linearGradient;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76.026,
    height: 78.662,
    viewBox: "0 0 20.115 20.813",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9fb00",
      stopOpacity: 1
    },
    offset: 0
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.9775 0 0 .9775 47.857 137.339)",
    x1: 2.002,
    y1: 12,
    x2: 21.998,
    y2: 12
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m67.778 140.72-4.282-1.426a3.91 3.91 0 0 1-7.82 0l-4.28 1.427a1.955 1.955 0 0 0-1.31 2.18l.566 3.391a.977.977 0 0 0 .968.821h2.102v9.775a1.96 1.96 0 0 0 1.955 1.955h7.82a1.955 1.955 0 0 0 1.954-1.955v-9.775h2.102a.977.977 0 0 0 .968-.82l.567-3.393a1.955 1.955 0 0 0-1.31-2.18z",
    style: {
      display: "inline",
      fill: "none",
      stroke: "url(#b)",
      strokeWidth: 1.05833,
      strokeDasharray: "none"
    },
    transform: "translate(-49.529 -138.56)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreen);
export default __webpack_public_path__ + "static/media/logo-green.165d865c4a3105f74371dfe3080ee7d5.svg";
export { ForwardRef as ReactComponent };